/* ============
 * Register Index Page
 * ============
 *
 * Page where the user can register
 */
import Vue from 'vue';
import accountService from '../../../services/account';
import mixin from '../../../mixins/mixin';

export default {

  data() {
    return {
      error: null,
    };
  },
  mixins: [mixin],
  methods: {
    confirmed (code) {
      accountService.confirmAccount(this, { confirmation_code: code });
    },
  },
  mounted() {
    var vm = this;

    if(vm.$route.params.confirmation_code) {
      vm.confirmed(vm.$route.params.confirmation_code);
    }
  }
};



// WEBPACK FOOTER //
// ./src/app/pages/confirm/index/index.js